module.exports = __webpack_public_path__ + "img/logo.da0ab004.png";